export default {
    diseaseTitle: "Disease Title",
    necessaryActions: "Necessary Actions",
    description: "description"
}